import { theme } from '../../theme/theme'
import { IconProps } from './types'

const DEFAULT_SIZE = 60
const DEFAULT_COLOR = theme.color.plum

export const Chat = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.5827 29.0417C37.5827 29.9478 37.2227 30.8169 36.582 31.4576C35.9412 32.0984 35.0722 32.4583 34.166 32.4583H11.6638C10.7578 32.4585 9.88887 32.8186 9.24827 33.4594L5.48652 37.2212C5.31689 37.3908 5.10078 37.5063 4.86552 37.553C4.63026 37.5998 4.3864 37.5758 4.16479 37.484C3.94318 37.3922 3.75376 37.2368 3.62048 37.0374C3.4872 36.8379 3.41605 36.6035 3.41602 36.3636V8.54167C3.41602 7.63551 3.77598 6.76647 4.41673 6.12572C5.05748 5.48497 5.92653 5.125 6.83268 5.125H34.166C35.0722 5.125 35.9412 5.48497 36.582 6.12572C37.2227 6.76647 37.5827 7.63551 37.5827 8.54167V29.0417Z"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.375 22.793H29.625" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.375 15.793H28.625" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
